import Vue from 'vue';
import VueResource from 'vue-resource';
import converterMoeda from '~js/converter-moeda';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import salvarArquivo from '~js/salvar-arquivo';
import formatarData from '~js/formatar-data';

Vue.use(VueResource);

async function normalizarParaVisualizar(solicitacao) {
  solicitacao.itensSolicitacaoImportacao.map(item => {
    item.quantidade = converterMoeda.paraReal(item.quantidade);
    item.valorEstimado = converterMoeda.paraReal(item.valorEstimado);
    item.desconto = converterMoeda.paraReal(item.desconto);
    item.vat = converterMoeda.paraReal(item.vat);
  });

  if (solicitacao.dataAprovacao) {
    solicitacao.dataAprovacao = await formatarData.paraData(solicitacao.dataAprovacao);
  }
  else
    solicitacao.dataAprovacao = '';

  if (solicitacao.dataProforma) {
    solicitacao.dataProforma = await formatarData.paraData(solicitacao.dataProforma);
  }
  else
    solicitacao.dataProforma = '';

  if (solicitacao.dataNR) {
    solicitacao.dataNR = await formatarData.paraData(solicitacao.dataNR);
  }
  else
    solicitacao.dataNR = '';

  if (solicitacao.cotacaoEstimada) {
    solicitacao.cotacaoEstimada = converterMoeda.paraCambio(solicitacao.cotacaoEstimada);
  }

  if (solicitacao.dataCoordenadorLibCanc) {
    solicitacao.dataCoordenadorLibCanc = moment(solicitacao.dataCoordenadorLibCanc).format('DD/MM/YYYY HH:mm:ss');
  }
  else
    solicitacao.dataCoordenadorLibCanc = '';
  
  return solicitacao;
}

async function normalizarParaSalvar(solicitacao) {
  delete solicitacao.projeto;
  delete solicitacao.importacaoMoeda;

  if (solicitacao.dataAprovacao) {
    solicitacao.dataAprovacao = await formatarData.paraNumero(solicitacao.dataAprovacao);
  }

  if (solicitacao.dataProforma) {
    solicitacao.dataProforma = await formatarData.paraNumero(solicitacao.dataProforma);
  }

  if (solicitacao.dataNR) {
    solicitacao.dataNR = await formatarData.paraNumero(solicitacao.dataNR);
  }

  return solicitacao;
}

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    const periodo = parametros.periodo;
    delete parametros.periodo;

    if (periodo) {
      parametros.dataInicio = moment(periodo[0], 'DD/MM/YYYY').format('MM/DD/YYYY');
      parametros.dataFim = moment(periodo[1], 'DD/MM/YYYY').format('MM/DD/YYYY');
    }

    return Vue.http.get('/api/solicitacaoimportacaoprojeto', { params: parametros });
  },
  adicionar: async (solicitacao, arquivos) => {
    solicitacao = await normalizarParaSalvar(solicitacao);
    solicitacao.arquivos = arquivos;

    solicitacao = converterObjetoFormData(solicitacao);

    return Vue.http.post('/api/solicitacaoimportacaoprojeto', solicitacao).then(res => res.data.id);
  },
  alterar: async (solicitacao, arquivos, id) => {
    solicitacao = await normalizarParaSalvar(solicitacao);
    solicitacao.arquivos = arquivos;

    solicitacao = converterObjetoFormData(solicitacao);

    return Vue.http.put(`/api/solicitacaoimportacaoprojeto/${id}`, solicitacao).then(res => res.data.id);
  },
  obterPorId: async id => {
    return Vue.http.get(`/api/solicitacaoimportacaoprojeto/${id}`)
      .then(response => response.data)
      .then(solicitacao => normalizarParaVisualizar(solicitacao));
  },
  liberar: id => {
    return Vue.http.post(`/api/solicitacaoimportacaoprojeto/${id}/liberar`)
      .then(response => response.data);
  },
  cancelar: id => {
    return Vue.http.post(`/api/solicitacaoimportacaoprojeto/${id}/cancelar`)
      .then(response => response.data);
  },
  arquivos: id => {
    return Vue.http.get(`/api/solicitacaoimportacaoprojeto/${id}/arquivos`)
      .then(response => response.data);
  },
  download: (id, arquivo) => {
    return Vue.http.get(`/api/solicitacaoimportacaoprojeto/${id}/downloadarquivo/${arquivo}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, arquivo);
      });
  },
  listaBancos: function () {
    return Vue.http.get('/api/solicitacaoimportacaoprojeto/bancos').then(response => response.data);
  },
  listaMoedas: function () {
    return Vue.http.get('/api/solicitacaoimportacaoprojeto/moedas').then(response => response.data);
  },
  listaFormaPagamentos: function () {
    return Vue.http.get('/api/solicitacaoimportacaoprojeto/formapagamentos').then(response => response.data);
  },
  listaIncoterm: function () {
    return Vue.http.get('/api/solicitacaoimportacaoprojeto/incoterm').then(response => response.data);
  },
  listaPrevisaoEntregas: function () {
    return Vue.http.get('/api/solicitacaoimportacaoprojeto/previsaoentregas').then(response => response.data);
  },
  listaTipoEmbarque: function () {
    return Vue.http.get('/api/solicitacaoimportacaoprojeto/tiposembarque').then(response => response.data);
  },
  listaDestinoCarga: function () {
    return Vue.http.get('/api/solicitacaoimportacaoprojeto/destinoscarga').then(response => response.data);
  },
  listaAgencias: function (idBanco) {
    return Vue.http.get(`/api/solicitacaoimportacaoprojeto/${idBanco}/agencias`).then(response => response.data);
  },
  listaContas: function (idAgencia) {
    return Vue.http.get(`/api/solicitacaoimportacaoprojeto/${idAgencia}/contas`).then(response => response.data);
  },
  getCotacaoEstimada: function (idImportacaoMoeda) {
    return Vue.http.get(`/api/solicitacaoimportacaoprojeto/${idImportacaoMoeda}/cotacaoMoeda`).then(response => response.data);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-importacao-projeto/servico.js